'use client'

import {
  toDate,
  convertDateTimeToDay,
  convertDateTimeToMonth,
  toDateTime,
  toTime,
} from '@repo/ui/lib/date-time'
import { useLanguage } from './use-language'

export const useDateTime = () => {
  const language = useLanguage()
  return {
    toDateTime: (date: Date, showSeconds?: boolean) =>
      toDateTime(date, language, showSeconds),
    toDate: (date: Date) => toDate(date, language),
    toTime: (date: Date) => toTime(date, language),
    convertDateTimeToMonth: (time: string | number) =>
      convertDateTimeToMonth(time, language),
    convertDateTimeToDay: (time: string | number) =>
      convertDateTimeToDay(time, language),
  }
}
